import React, { useMemo, useState } from 'react';
import OrderLogs from '../../components/OrderLogs';
import PaymentLogs from '../../components/PaymentLogs';
import { TWSelect } from '../../../../components/ui';

const cn = (...c) => c.filter(Boolean).join(' ');

const LogsTabs = ({ orderDetail, onClickOpenStripeNewTab }) => {
  const [active, setActive] = useState('orderlogs');

  const tabs = useMemo(
    () => [
      {
        value: 'orderlogs',
        label: 'Order Logs',
        component: <OrderLogs logs={orderDetail.logs} />,
      },
      {
        value: 'paymentlogs',
        label: 'Payment Logs',
        component: (
          <PaymentLogs
            payments={orderDetail.payments}
            onClickOpenStripeNewTab={onClickOpenStripeNewTab}
          />
        ),
      },
    ],
    [orderDetail.logs, orderDetail.payments, onClickOpenStripeNewTab],
  );

  const currentTab = tabs.find((t) => t.value === active) || tabs[0];

  return (
    <section
      className="reveal overflow-hidden rounded-md border border-slate-200 bg-white shadow-sm dark:border-slate-700 dark:bg-slate-800"
      aria-label="Order logs"
    >
      <div className="border-b border-slate-100 px-5 dark:border-slate-700/60">
        <div className="py-3 sm:hidden">
          <TWSelect
            value={active}
            onChange={setActive}
            options={tabs.map((t) => ({ label: t.label, value: t.value }))}
          />
        </div>
        <nav className="hidden gap-6 sm:flex" aria-label="Log tabs">
          {tabs.map((tab) => {
            const isActive = tab.value === active;
            return (
              <button
                key={tab.value}
                type="button"
                onClick={() => setActive(tab.value)}
                className={cn(
                  'relative inline-flex items-center border-b-2 px-1 py-3 text-sm font-semibold transition',
                  isActive
                    ? 'border-blue-500 text-blue-600 dark:border-sky-400 dark:text-sky-400'
                    : 'border-transparent text-slate-500 hover:text-slate-700 dark:text-slate-400 dark:hover:text-slate-200',
                )}
              >
                {tab.label}
              </button>
            );
          })}
        </nav>
      </div>
      <div className="p-5">{currentTab.component}</div>
    </section>
  );
};

export default LogsTabs;
